import http, { GetIdiomaFiltro } from "../config/axiosConfig/http-common";
import ServiceBase from "./service.base";

class ProdutoService extends ServiceBase {

  getProdutoTraduzido(produto) {
    const nometraduzido = produto?.Traducoes.find((item) => item.Idioma === GetIdiomaFiltro());
    return nometraduzido ? nometraduzido.Traducao : produto.Nome;
  }

  getAll(filter, idTabelaPreco) {
    const consulta =
      idTabelaPreco
        ? `/produtos/tabelapreco/${idTabelaPreco}${this.getFilter(filter)}`
        : `/produtos${this.getFilter(filter)}`
    return http.get(consulta);
  }

  getAllFiname(filter) {
    const consulta = `/produtos/finame${this.getFilter(filter)}`
    return http.get(consulta);
  }

  get(id, idTabelaPreco, filter) {
    let consulta =
      idTabelaPreco
        ? `/produtos/${id}/tabelapreco/${idTabelaPreco}`
        : `/produtos/${id}`

    if (filter) {
      consulta = `${consulta}${this.getFilter(filter)}`
    }

    return http.get(consulta);
  }

  getFiname(id) {
    const consulta = `/produtos/finame/${id}`
    return http.get(consulta);
  }

  getReferencia(id, idTabelaPreco, filter) {
    let consulta =
      idTabelaPreco
        ? `/produtos/referencia/${id}/tabelapreco/${idTabelaPreco}`
        : `/produtos/referencia/${id}`

    if (filter) {
      consulta = `${consulta}${this.getFilter(filter)}`
    }        

    return http.get(consulta);
  }

  postFormula(id, data) {
    return http.post(`/produtos/${id}/formula`, data);
  }

  getAtributosFormula(id) {
    return http.get(`/produtos/${id}/atributosformula`);
  }

  getAtributos(id) {
    return http.get(`/produtos/${id}/atributos`);
  }

  getImage(id) {
    return http.get(`/produtos/${id}/image`);
  }

  getComposicao(id) {
    return http.get(`/produtos/${id}/composicao`);
  }

  getComposicaoAssistencia(id) {
    return http.get(`/produtos/${id}/composicaoassistencia`);
  }
  getProdutoComposicaoAssistencia(idMestre, idProduto) {
    return http.get(`/produtos/${idMestre}/produtocomposicaoassistencia/${idProduto}`);
  }

  getImageLink(id) {
    return `${http.getUri()}/produtos/${id}/image`;
  }

  getPrecosViaScript(id, idCondicaoPagamento, idCliente, PercentualAcrescimo) {
    return http.get(`/produtos/${id}/precosscript?IdCondicaoPagamento=${idCondicaoPagamento}&IdCliente=${idCliente}&PercentualAcrescimo=${PercentualAcrescimo}`);
  }

  getEstoqueDisponivelVenda(id) {
    return http.get(`/produtos/${id}/estoquedisponivelvenda`);
  }

}

export default new ProdutoService();